import React from 'react';
import { ShieldCheck, TrendingUp, Zap, Clock, Package, CheckCircle2 } from 'lucide-react';
export const WholesaleApply = () => {
  return <div className="bg-gray50 min-h-screen" data-id="element-647">
      {/* Hero Section */}
      <div className="bg-ink text-white py-16 lg:py-24 border-b border-gray-800" data-id="element-648">
        <div className="max-w-7xl mx-auto px-4 text-center max-w-3xl" data-id="element-649">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold mb-6 leading-tight" data-id="element-650">
            Apply for Wholesale Access
          </h1>
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-651">
            Get access to private-label custom uniform production, wholesale
            support, and dealer-focused pricing.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 lg:py-20" data-id="element-652">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-653">
          {/* Left Column: Info & Benefits */}
          <div className="lg:col-span-5 flex flex-col gap-12" data-id="element-654">
            <div data-id="element-655">
              <h2 className="text-2xl font-heading font-bold text-ink mb-4" data-id="element-656">
                Why Partner With Us?
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-657">
                Custom Uniform Supplier is built exclusively for dealers,
                resellers, decorators, and team stores. We don't compete with
                you for retail customers. We provide the production engine
                behind your brand.
              </p>
              <ul className="flex flex-col gap-4" data-id="element-658">
                {[{
                icon: ShieldCheck,
                text: 'Private-label production protects your brand'
              }, {
                icon: TrendingUp,
                text: 'Wholesale pricing protects your margins'
              }, {
                icon: Package,
                text: 'Combined quantity pricing for competitive bids'
              }, {
                icon: Zap,
                text: 'Speed Rush production available'
              }, {
                icon: Clock,
                text: 'USA-time support 9am–10pm EST'
              }].map((benefit, i) => <li key={i} className="flex items-center gap-3 text-charcoal font-medium" data-id="element-659">
                    <div className="w-8 h-8 rounded-full bg-brandRed/10 flex items-center justify-center shrink-0" data-id="element-660">
                      <benefit.icon className="w-4 h-4 text-brandRed" data-id="element-661" />
                    </div>
                    <span data-id="element-662">{benefit.text}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-white p-6 rounded-xl border border-gray200 shadow-sm" data-id="element-663">
              <h3 className="font-heading font-bold text-lg text-ink mb-4" data-id="element-664">
                What happens after applying?
              </h3>
              <div className="space-y-4" data-id="element-665">
                <div className="flex gap-4" data-id="element-666">
                  <div className="w-6 h-6 rounded-full bg-charcoal text-white text-xs font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-667">
                    1
                  </div>
                  <div data-id="element-668">
                    <h4 className="font-bold text-sm text-ink" data-id="element-669">
                      Application Review
                    </h4>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-670">
                      Our team verifies your business details to ensure you
                      qualify for wholesale pricing.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-671">
                  <div className="w-6 h-6 rounded-full bg-charcoal text-white text-xs font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-672">
                    2
                  </div>
                  <div data-id="element-673">
                    <h4 className="font-bold text-sm text-ink" data-id="element-674">
                      Account Setup
                    </h4>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-675">
                      Once approved, you'll receive login credentials to access
                      pricing and the dealer portal.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-676">
                  <div className="w-6 h-6 rounded-full bg-charcoal text-white text-xs font-bold flex items-center justify-center shrink-0 mt-0.5" data-id="element-677">
                    3
                  </div>
                  <div data-id="element-678">
                    <h4 className="font-bold text-sm text-ink" data-id="element-679">
                      Start Building
                    </h4>
                    <p className="text-sm text-gray-600 mt-1" data-id="element-680">
                      Use the Kit Builder to design uniforms and submit them
                      directly for wholesale production.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Application Form */}
          <div className="lg:col-span-7" data-id="element-681">
            <div className="bg-white rounded-xl border border-gray200 shadow-xl overflow-hidden" data-id="element-682">
              <div className="bg-gray50 border-b border-gray200 p-6 md:p-8" data-id="element-683">
                <h2 className="text-2xl font-heading font-bold text-ink" data-id="element-684">
                  Dealer Application
                </h2>
                <p className="text-sm text-gray-500 mt-2" data-id="element-685">
                  Please provide your business information to request access.
                </p>
              </div>

              <form className="p-6 md:p-8 flex flex-col gap-6" onSubmit={e => e.preventDefault()} data-id="element-686">
                {/* Business Info */}
                <div className="space-y-4" data-id="element-687">
                  <h3 className="font-bold text-sm text-gray-400 uppercase tracking-wider border-b border-gray100 pb-2" data-id="element-688">
                    Business Information
                  </h3>

                  <div className="grid md:grid-cols-2 gap-4" data-id="element-689">
                    <div className="flex flex-col gap-1.5" data-id="element-690">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-691">
                        Company Name *
                      </label>
                      <input type="text" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-692" />
                    </div>
                    <div className="flex flex-col gap-1.5" data-id="element-693">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-694">
                        Business Type *
                      </label>
                      <select className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all bg-white" required data-id="element-695">
                        <option value="" data-id="element-696">Select type...</option>
                        <option value="dealer" data-id="element-697">Team Dealer</option>
                        <option value="decorator" data-id="element-698">
                          Decorator / Screen Printer
                        </option>
                        <option value="retail" data-id="element-699">Sporting Goods Store</option>
                        <option value="apparel" data-id="element-700">
                          Apparel Brand / Reseller
                        </option>
                        <option value="other" data-id="element-701">Other Wholesale Buyer</option>
                      </select>
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-4" data-id="element-702">
                    <div className="flex flex-col gap-1.5" data-id="element-703">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-704">
                        Tax ID / EIN *
                      </label>
                      <input type="text" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-705" />
                    </div>
                    <div className="flex flex-col gap-1.5" data-id="element-706">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-707">
                        Website
                      </label>
                      <input type="url" placeholder="https://" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" data-id="element-708" />
                    </div>
                  </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-4 mt-2" data-id="element-709">
                  <h3 className="font-bold text-sm text-gray-400 uppercase tracking-wider border-b border-gray100 pb-2" data-id="element-710">
                    Primary Contact
                  </h3>

                  <div className="grid md:grid-cols-2 gap-4" data-id="element-711">
                    <div className="flex flex-col gap-1.5" data-id="element-712">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-713">
                        First Name *
                      </label>
                      <input type="text" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-714" />
                    </div>
                    <div className="flex flex-col gap-1.5" data-id="element-715">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-716">
                        Last Name *
                      </label>
                      <input type="text" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-717" />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-2 gap-4" data-id="element-718">
                    <div className="flex flex-col gap-1.5" data-id="element-719">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-720">
                        Email Address *
                      </label>
                      <input type="email" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-721" />
                    </div>
                    <div className="flex flex-col gap-1.5" data-id="element-722">
                      <label className="text-sm font-semibold text-charcoal" data-id="element-723">
                        Phone Number *
                      </label>
                      <input type="tel" className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all" required data-id="element-724" />
                    </div>
                  </div>
                </div>

                {/* Additional Details */}
                <div className="space-y-4 mt-2" data-id="element-725">
                  <h3 className="font-bold text-sm text-gray-400 uppercase tracking-wider border-b border-gray100 pb-2" data-id="element-726">
                    Additional Details
                  </h3>

                  <div className="flex flex-col gap-1.5" data-id="element-727">
                    <label className="text-sm font-semibold text-charcoal" data-id="element-728">
                      Primary Sports / Categories of Interest
                    </label>
                    <textarea rows={3} className="w-full px-4 py-2.5 rounded-sm border border-gray200 focus:border-brandRed focus:ring-1 focus:ring-brandRed outline-none transition-all resize-none" placeholder="e.g., Football, Baseball, Basketball..." data-id="element-729"></textarea>
                  </div>
                </div>

                <div className="bg-gray50 p-4 rounded border border-gray200 flex items-start gap-3 mt-4" data-id="element-730">
                  <input type="checkbox" id="terms" className="mt-1 w-4 h-4 text-brandRed rounded border-gray300 focus:ring-brandRed" required data-id="element-731" />
                  <label htmlFor="terms" className="text-sm text-gray-600 leading-relaxed" data-id="element-732">
                    I confirm that I am applying on behalf of a business entity
                    (dealer, reseller, decorator, etc.) and not for a single
                    retail/team order. I understand that wholesale pricing
                    requires approval.
                  </label>
                </div>

                <button type="submit" className="w-full bg-brandRed hover:bg-brandRedDark text-white font-bold py-4 px-6 rounded-sm text-center transition-colors shadow-lg mt-4 text-lg" data-id="element-733">
                  Submit Wholesale Application
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>;
};